'use strict';exports.__esModule = true;exports.resetPaymentData = exports.clearPaymentData = exports.failPayment = exports.successPayment = exports.changeSelectedPayment = exports.inquirePayment = exports.verifyPayment = exports.sendPaymentRequest = undefined;var _reduxAct = require('redux-act');
var _index = require('axios/index');var _index2 = _interopRequireDefault(_index);
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// Helpers
var promise = _reduxLoop.Effects.promise;

var sendPaymentRequest = (0, _reduxAct.createAction)('/SEND_PAYMENT_REQUEST');
var sendRequestSuccess = (0, _reduxAct.createAction)('/SEND_PAYMENT_REQUEST_SUCCESS');
var sendRequestFail = (0, _reduxAct.createAction)('/SEND_PAYMENT_REQUEST_FAIL');
var verifyPayment = (0, _reduxAct.createAction)('/NOTE_SUCCESS_PAYMENT');
var verifyPaymentSuccess = (0, _reduxAct.createAction)('/NOTE_PAYMENT_SUCCESS');
var verifyPaymentFail = (0, _reduxAct.createAction)('/NOTE_PAYMENT_FAIL');
var inquirePayment = (0, _reduxAct.createAction)('/NOTE_INQUIRE_PAYMENT');
var inquirePaymentSuccess = (0, _reduxAct.createAction)('/NOTE_INQUIRE_SUCCESS');
var inquirePaymentFail = (0, _reduxAct.createAction)('/NOTE_INQUIRE_FAIL');
var changeSelectedPayment = (0, _reduxAct.createAction)('/CHANGE_SELECTED_PAYMENT');
var successPayment = (0, _reduxAct.createAction)('/SUCCESS_PAYMENT');
var failPayment = (0, _reduxAct.createAction)('/FAIL_PAYMENT');
var clearPaymentData = (0, _reduxAct.createAction)('/CLEAR_PAYMENT_DATA');
var resetPaymentData = (0, _reduxAct.createAction)('/RESET_PAYMENT_DATA');

var initialState = {
  sending: false,
  sent: false,
  isSuccessPaid: false,
  isSuccessVerified: false,
  isSuccessInquired: false,
  iframeLoading: false,
  isRequestFailed: false,
  selectedPackage: {},
  paidProducts: null };


var fetchReceive = function fetchReceive(_ref) {var data = _ref.data,token = _ref.token;return _index2.default.
  post('/payments/pay', data, { headers: { access_token: token } }).
  then(sendRequestSuccess, sendRequestFail);};

var handleSendRequest = function handleSendRequest(state, paymentData) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    sending: true,
    sent: false,
    paymentData: null,
    error: null,
    iframeLoading: true,
    paidProducts: null }),
  promise(fetchReceive, paymentData));};

var handleSendSuccessRequest = function handleSendSuccessRequest(state, _ref2) {var _ref2$data = _ref2.data,redirectUrl = _ref2$data.redirectUrl,transactionId = _ref2$data.token;return Object.assign({},
  state, {
    sending: false,
    sent: true,
    iframeLoading: false,
    transactionId: transactionId,
    redirectUrl: redirectUrl });};


var handleSendFailRequest = function handleSendFailRequest(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while payment send');

  error.status = response.response.status;

  return Object.assign({},
  state, {
    sending: false,
    sent: false,
    paymentData: null,
    iframeLoading: false,
    error: error });

};

var fetchNote = function fetchNote(_ref3) {var data = _ref3.data,token = _ref3.token;return _index2.default.
  post('/payments/verify', data, { headers: { access_token: token } }).
  then(verifyPaymentSuccess, verifyPaymentFail);};

var handleVerifyPayment = function handleVerifyPayment(state, data) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    paidProducts: null }),
  promise(fetchNote, data));};

var handleVerifyPaymentSuccess = function handleVerifyPaymentSuccess(state, _ref4) {var data = _ref4.data;return Object.assign({},
  state, {
    paidProducts: data.payment.products,
    updatedToken: data.user.access_token,
    isSuccessVerified: true });};



var handleVerifyPaymentFail = function handleVerifyPaymentFail(state) {return Object.assign({},
  state, {
    paidProducts: null,
    isSuccessVerified: false });};


var fetchInquire = function fetchInquire(_ref5) {var data = _ref5.data,token = _ref5.token;return _index2.default.
  post('/payments/inquire', data, { headers: { access_token: token } }).
  then(inquirePaymentSuccess, inquirePaymentFail);};

var handleInquirePayment = function handleInquirePayment(state, data) {return (0, _reduxLoop.loop)(Object.assign({},
  state),
  promise(fetchInquire, data));};

var handleInquirePaymentSuccess = function handleInquirePaymentSuccess(state) {return Object.assign({},
  state, {
    isSuccessInquired: true });};


var handleInquirePaymentFail = function handleInquirePaymentFail(state) {return Object.assign({},
  state, {
    isSuccessInquired: false });};


var handleChangeSelectedPayment = function handleChangeSelectedPayment(state, change) {return Object.assign({},
  state, {
    selectedPackage: Object.assign({},
    state.selectedPackage,
    change, {
      type: change.type }) });};



var handleSuccessPayment = function handleSuccessPayment(state) {return Object.assign({},
  state, {
    isSuccessPaid: true,
    isRequestFailed: false });};


var handleFailPayment = function handleFailPayment(state) {return Object.assign({},
  state, {
    isSuccessPaid: false,
    isRequestFailed: true });};


var handleClearPaymentData = function handleClearPaymentData(state) {return Object.assign({},
  state, {
    isSuccessPaid: false,
    isRequestFailed: false });};


var handleResetPaymentData = function handleResetPaymentData(state) {return Object.assign({},
  state,
  initialState);};


var payments = (0, _reduxAct.createReducer)(function (on) {
  on(sendPaymentRequest, handleSendRequest);
  on(sendRequestSuccess, handleSendSuccessRequest);
  on(sendRequestFail, handleSendFailRequest);
  on(verifyPayment, handleVerifyPayment);
  on(verifyPaymentSuccess, handleVerifyPaymentSuccess);
  on(verifyPaymentFail, handleVerifyPaymentFail);
  on(inquirePayment, handleInquirePayment);
  on(inquirePaymentSuccess, handleInquirePaymentSuccess);
  on(inquirePaymentFail, handleInquirePaymentFail);
  on(changeSelectedPayment, handleChangeSelectedPayment);
  on(successPayment, handleSuccessPayment);
  on(failPayment, handleFailPayment);
  on(clearPaymentData, handleClearPaymentData);
  on(resetPaymentData, handleResetPaymentData);
}, initialState);exports.


sendPaymentRequest = sendPaymentRequest;exports.
verifyPayment = verifyPayment;exports.
inquirePayment = inquirePayment;exports.
changeSelectedPayment = changeSelectedPayment;exports.
successPayment = successPayment;exports.
failPayment = failPayment;exports.
clearPaymentData = clearPaymentData;exports.
resetPaymentData = resetPaymentData;exports.default =


payments;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/payments.js
// module id = 132
// module chunks = 0